import _ from 'lodash';
import { sortBy } from 'lodash/sortBy'; /* eslint no-unused-vars: 0 */
import { groupBy } from 'lodash/groupBy'; /* eslint no-unused-vars: 0 */
import moment from 'moment';

const SELECTOR = '[data-detail-view-availability]';

const bookedHoursTemplate = (start, end) => `${start} — ${end}`;
const formatDay = dayDate => {
  return moment(dayDate).format('DD/MM/YYYY');
};
const getTimeFromMinutes = minutesFromMidnight => {
  const h = (minutesFromMidnight / 60) | 0,
    m = (minutesFromMidnight % 60) | 0;

  return moment
    .utc()
    .hours(h)
    .minutes(m)
    .format('hh:mm A');
};

class BookedHoursTooltips {
  constructor() {
    this.data = this.getDataGroupedByDate();
    this.initialize();
  }

  initialize() {
    Object.keys(this.data).forEach(dayDate => {
      const $td = this.findCellByDate(formatDay(dayDate));
      const tooltipBody = this.buildTooltipBody(dayDate);

      this.addTooltipDataAttribute($td, tooltipBody);
    });
  }

  buildTooltipBody(dayDate) {
    return this.data[dayDate]
      .map(hours => {
        const start = getTimeFromMinutes(hours.start_minute);
        const end = getTimeFromMinutes(hours.end_minute);

        return bookedHoursTemplate(start, end);
      })
      .join('\n');
  }

  getDataGroupedByDate() {
    const data = $(SELECTOR).data('booked');
    const sortedByStartMinute = _.sortBy(data, [p => p.start_minute]);
    const groupedByDate = _.groupBy(sortedByStartMinute, p => p.date);

    return groupedByDate;
  }

  findCellByDate(dayDate) {
    return $(`[data-day="${dayDate}"]`);
  }

  addTooltipDataAttribute($td, content) {
    $td.attr({
      'data-toggle': 'tooltip',
      'data-container': 'body',
      title: content
    });
  }
}

export default BookedHoursTooltips;



// WEBPACK FOOTER //
// ./src/javascripts/DetailView/BookedHoursTooltips.js